import Vue from 'vue';
import Router from 'vue-router';

import { store, StoreMutations } from '@/store';
import { userService } from './user.service';

import { Login, Home, Ordini, OrdiniMTM, OrdineDettaglio, OrdineMTMDettaglio, Lavorazioni, LavorazioneDettaglio, Consumi, DistintaDettaglio, Spedizioni, SpedizioneDettaglio, NuovaSpedizione, StampaDdt, Reintegri, ReintegroDettaglio, Venduto, OrdineSpacchettato } from '@/views';
import { AzioniLavorazioni, OpzioniLavorazioni, OpzioniLavorazioniComandi, OpzioniOrdine, OpzioniOrdini, OpzioniOrdiniComandi, OpzioniOrdiniMTM, OpzioniOrdiniMTMComandi, OpzioniSpedizioniComandi,OpzioniSpedizioni, OpzioniReintegriComandi, OpzioniReintegri } from '@/components';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { auth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/ordini-mtm',
      name: 'ordini-mtm',
      components: {
        default: OrdiniMTM,
        "global-commands": OpzioniOrdiniMTMComandi,
        "options-content": OpzioniOrdiniMTM
      },
      meta: { auth: true, titolo: "Ordini MTM" }
    },
    {
      path: '/ordine-mtm/:id/:idRiga?/:idLavorazioneAssociata?',
      name: 'ordine-mtm',
      components: {
        default: OrdineMTMDettaglio,
        //"options-content": OpzioniOrdine
      },
      meta: {
        auth: true,
        titolo: "Dettaglio ordine MTM",
      }
    },
    {
      path: '/ordini',
      name: 'ordini',
      components: {
        default: Ordini,
        "global-commands": OpzioniOrdiniComandi,
        "options-content": OpzioniOrdini
      },
      meta: { auth: true, titolo: "Ordini" }
    },
    {
      path: '/ordine/:id',
      name: 'ordine',
      components: {
        default: OrdineDettaglio,
        "options-content": OpzioniOrdine
      },
      meta: {
        auth: true,
        selezioneRigheAttiva: false,
        titolo: "Dettaglio ordine",
      }
    },
    {
      path: '/spedizione/:id',
      name: 'spedizione',
      components: {
        default: SpedizioneDettaglio
      },
      meta: {
        auth: true,
        titolo: "Dettaglio spedizione",
      }
    },
    {
      path: '/righe',
      name: 'righe',
      components: {
        default: Lavorazioni,
        "global-commands": OpzioniLavorazioniComandi,
        "options-content": OpzioniLavorazioni,
        "actions-content": AzioniLavorazioni,
      },
      meta: {
        auth: true,
        selezioneRigheAttiva: true,
        titolo: "Righe consegna" ,
      }
    },
    {
      path: '/riga/:id',
      name: 'riga',
      component: LavorazioneDettaglio,
      meta: { auth: true, titolo: "Dettaglio riga consegna" }
    },
    {
      path: '/oaf/:id',
      name: 'oaf',
      component: OrdineSpacchettato,
      meta: { auth: true, titolo: "Ordini Avanzamento Fasi" }
    },
    {
      path: '/spedizioni',
      name: 'spedizioni',
      components: {
        default: Spedizioni,
        "global-commands": OpzioniSpedizioniComandi,
        "options-content": OpzioniSpedizioni
      },
      meta: { auth: true, titolo: "Spedizioni" }
    },
    // {
    //   path: '/spedisci',
    //   name: 'spedisci',
    //   components: {
    //     default: NuovaSpedizione,
    //     // "global-commands": OpzioniLavorazioniComandi,
    //     // "options-content": OpzioniLavorazioni
    //   },
    //   meta: { auth: true, titolo: "Crea spedizione" }
    // },
    {
      path: '/consumi',
      name: 'consumi',
      components: {
        default: Consumi,
        // "global-commands": OpzioniOrdiniComandi,
        // "options-content": OpzioniOrdini
      },
      meta: { auth: true, titolo: "Consumi" }
    },
    {
      path: '/distinta/:id',
      name: 'distinta',
      component: DistintaDettaglio,
      meta: { auth: true, titolo: "Distinta Statica" }
    },
    // {
    //   path: '/ordine/:id',
    //   name: 'ordine',
    //   components: {
    //     default: OrdineDettaglio,
    //     "options-content": OpzioniOrdine
    //   },
    //   meta: {
    //     auth: true,
    //     selezioneRigheAttiva: false,
    //     titolo: "Dettaglio ordine",
    //   }
    // },
    {
      path: '/ddt/:id',
      name: 'ddt',
      component: StampaDdt,
      meta: { auth: true, titolo: "Dettaglio DDT" }
    },
    {
      path: '/reintegri',
      name: 'reintegri',
      components: {
        default: Reintegri,
        "global-commands": OpzioniReintegriComandi,
        "options-content": OpzioniReintegri
      },
      meta: { auth: true, titolo: "Reintegri" }
    },
    {
      path: '/reintegro/:id',
      name: 'reintegro',
      component: ReintegroDettaglio,
      meta: { auth: true, titolo: "Dettaglio reintegro" }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting, this generates a separate chunk (about.[hash].js) for this route which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
      meta: { auth: true }
    },
    {
      path: '/venduto',
      name: 'venduto',
      component: Venduto,
      meta: { auth: true, titolo: "Venduto" }
    },
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = userService.isUserLogged();

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  if(loggedIn && to.path === '/login') {
    return next('/');
  }

  next();
})

router.afterEach((to, from) => {
  let titolo = "Filolog";
  if(to.meta && to.meta.titolo) {
    titolo = to.meta.titolo;
  }
  store.commit(StoreMutations.SetTitoloPagina, titolo);
  store.commit(StoreMutations.SetSottotitoloPagina);
});